import { render, staticRenderFns } from "./ErrorDetailView.vue?vue&type=template&id=2a222a13"
import script from "./ErrorDetailView.vue?vue&type=script&lang=js"
export * from "./ErrorDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports